import { gql } from "@apollo/client";

export const GET_OPTION_VALUE = gql`
  query OptionValue($where: OptionValueWhereInputOne!) {
    optionValue(where: $where) {
      id
      name
      value
      shop {
        id
        name
      }
      isDeleted
      createdAt
      updatedAt
      note
    }
}
`;

export const GET_OPTION_VALUES = gql`
  query OptionValues($where: OptionValueWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
    optionValues(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      total
      data {
        id
        name
        value
        shop {
          id
          name
        }
        isDeleted
        createdAt
        updatedAt
        note
      }
    }
}
`;